import React from 'react';
import { Button } from '@mui/material';

const CustomButton = ({
	isDisabled = false,
	buttonName,
	iconSrc,
	buttonColor,
	hoverColor,
	titleColor,
	titleHoverColor,
	width = 'auto',
	height = 'auto',
	padding = '12px 20px',
	borderColor = 'transparent',
	borderWidth = '0px',
	onClick,
}) => {
	return (
		<Button
			disabled={isDisabled}
			variant='contained'
			disableElevation
			onClick={onClick}
			sx={{
				backgroundColor: buttonColor,
				color: titleColor,
				padding: padding,
				width: width,
				height: height,
				borderRadius: '8px',
				fontFamily: 'Satoshi, sans-serif',
				fontWeight: 700,
				fontSize: '14px',
				textTransform: 'none',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				transition: 'background-color 0.2s, color 0.2s',
				border: `${borderWidth} solid ${borderColor}`,
				'&:hover': {
					backgroundColor: hoverColor,
					color: titleHoverColor,
				},
			}}>
			<span style={{ display: 'flex', alignItems: 'center' }}>
				<span style={{ marginRight: iconSrc ? '8px' : '0' }}>{buttonName}</span>
				{iconSrc && (
					<img
						src={iconSrc}
						alt={`${buttonName} icon`}
						style={{
							width: '14px',
							height: '14px',
							objectFit: 'contain',
						}}
					/>
				)}
			</span>
		</Button>
	);
};

export default CustomButton;
